import { Inject } from '@angular/core';
import '@angular/compiler';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageDigital_twinPidComponent } from './page.digital_twin.pid/page.digital_twin.pid.component';
import { PageActuatorComponent } from './page.actuator/page.actuator.component';
import { PageProjectsItemComponent } from './page.projects.item/page.projects.item.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageDigital_twinMcuComponent } from './page.digital_twin.mcu/page.digital_twin.mcu.component';
import { PageDigital_twinKinematicsComponent } from './page.digital_twin.kinematics/page.digital_twin.kinematics.component';
import { PageDigital_twinComponent } from './page.digital_twin/page.digital_twin.component';
import { PageProjectsComponent } from './page.projects/page.projects.component';
import { PageSimulationComponent } from './page.simulation/page.simulation.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageReportsComponent } from './page.reports/page.reports.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe', standalone: false })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        ComponentNavSidebarComponent,
        PortalSeasonTreeComponent,
        PageHomeComponent,
        PageAdminComponent,
        PortalSeasonModalComponent,
        LayoutEmptyComponent,
        PageDigital_twinPidComponent,
        PageActuatorComponent,
        PageProjectsItemComponent,
        LayoutSidebarComponent,
        PortalSeasonFormDropdownComponent,
        PageDashboardComponent,
        PageMypageComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonLoadingDefaultComponent,
        PageDigital_twinMcuComponent,
        PageDigital_twinKinematicsComponent,
        PageDigital_twinComponent,
        PageProjectsComponent,
        PageSimulationComponent,
        PageAccessComponent,
        PageReportsComponent,
        PortalSeasonPaginationComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }